module.exports = __webpack_public_path__ + "514dfdf94347917c7ba0fd2ce5bca625.woff2";